var serialize = function (data) {
    return Object.keys(data).map(function (keyName) {
        return encodeURIComponent(keyName) + '=' + encodeURIComponent(data[keyName])
    }).join('&');
};

module.exports = {
    serialize
};



/** WEBPACK FOOTER **
 ** ./src/app/helpers/index.js
 **/